import CardEvaluated from "components/ui/CardEvaluated";
import CardEvaluation from "components/ui/CardEvaluation";
import Filter from "components/ui/Filter";
import NavTab, { TabItem } from "components/ui/NavTab";
import Pagination from "components/ui/Pagination";
import Spinner from "components/ui/Spinner";
import { useAuth } from "context/AuthContext";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import {
  getEvaluatedRealizations,
  getEvaluatedRealizationsDirector,
} from "services/evaluation.service";
import { RealizationEvItem } from "types/realization";
import { categories } from "types/realization";
import { StageIds } from "utils/constants";

const DirectorEvaluation = () => {
  const navigate = useNavigate();
  const { user, updateNotifications, currentStep } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [listEvaluated, setListEvaluated] = useState<RealizationEvItem[]>([]);

  const [categories, setCategories] = useState<categories[]>([]);
  const [realizations, setRealizations] = useState<RealizationEvItem[]>([]);
  const [filteredRealization, setFilteredRealization] = useState<
    RealizationEvItem[]
  >([]);
  const [filter, setFilter] = useState<{
    category?: string;
    searchTerm?: string;
  }>({});

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const [currentItens, setCurrentItens] = useState<RealizationEvItem[]>([]);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    fetchRealizations();
  }, [user]);

  const fetchRealizations = async () => {
    setIsLoading(true);
    try {
      if (!!user) {
        let data = await getEvaluatedRealizationsDirector(user, true);

        const items = data
          ? data.flatMap((item: any) => item.realizations)
          : [];

        if (items.length === 0) {
          // if (currentStep?._id === StageIds.STAGE_TRES_AVALIACAO_DIRETOR) {
          if (user.detail.isBoss ) {
            navigate("/evaluation-realization/vote");
          } else {
            navigate("/winners");
          }
        } else {
          let newCategories = data
            ? data.map((item: any) => {
                return {
                  name: `${item.categoryName}(${
                    item.realizations.length || 0
                  })`,
                  _id: item.categoryName,
                };
              })
            : [];

          newCategories.unshift({
            name: `Ver Todas (${items.length})`,
            _id: -1,
          });
          setCategories(newCategories);

          setRealizations(items);
          setFilteredRealization(items);

          const indexOfLastItem = currentPage * perPage;
          const indexOfFirstItem = indexOfLastItem - perPage;
          const totalPages = Math.ceil(items.length / perPage);
          setTotalPages(totalPages);
        }
      }
    } catch (e) {
      navigate("/winners");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = (term: string) => {
    let filteredResult =
      term === "-1"
        ? realizations
        : realizations.filter((item) => {
            const matchesCategory =
              item.categoria.toLowerCase() === term.toLocaleLowerCase();
            return matchesCategory;
          });

    console.log(filteredResult.length);
    setFilteredRealization(filteredResult);
    setCurrentPage(1);
  };

  useEffect(() => {
    const indexOfLastItem = currentPage * perPage;
    const indexOfFirstItem = indexOfLastItem - perPage;
    setCurrentItens(
      filteredRealization.slice(indexOfFirstItem, indexOfLastItem)
    );

    const totalPages = Math.ceil(filteredRealization.length / perPage);
    setTotalPages(totalPages);
  }, [currentPage, perPage, filteredRealization]);

  return isLoading ? (
    <div className="flex items-start justify-center w-full h-screen">
      <div className="flex flex-col">
        <Spinner />
        <span className="text-center text-blue-bb">Carregando...</span>
      </div>
    </div>
  ) : (
    <div className="flex flex-col items-start justify-between mx-4 gap-9 md:flex-row md:mx-0">
      <div className="flex-1">
        <div className="relative top-0 md:top-8">
          <h2 className="mb-3 text-[32px] font-bold text-black-bb font-title">
            Esses foram seus votos!
          </h2>
        </div>

        <div>
          <div className="flex items-end justify-end my-14">
            <div className="w-full">
              <Filter
                hideTextFilter={true}
                inEnd={true}
                categories={categories}
                enableCategoryFilter={true}
                onChange={(key, value) => {
                  handleSearch(value);
                  setFilter((prev) => ({ ...filter, [key]: value }));
                }}
              />
            </div>
          </div>
        </div>

        <div>
          {isLoading ? (
            <div className="flex items-start justify-center w-full h-screen">
              <div className="flex flex-col">
                <Spinner />
                <span className="text-center text-blue-bb">Carregando...</span>
              </div>
            </div>
          ) : (
            <>
              <div className="grid-cols-1 mx-4 md:grid md:mx-0 md:grid-cols-2 gap-7 content">
                {currentItens.map((item: RealizationEvItem, index: number) => (
                  <CardEvaluated data={item} key={item._id} onlyResult={true} />
                ))}
              </div>
            </>
          )}
          <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            onPage={setCurrentPage}
          />
        </div>
      </div>
    </div>
  );
};

export default DirectorEvaluation;
